import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, useState, useRef } from "react"
import classnames from "classnames"
import { Link } from "react-router-dom"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
} from "reactstrap"

import DetailTableActiveComponent from './Components/DetailTableActiveComponent'

const IndexView = (props) => {

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">

                        <Card>
                            <CardBody>
                                <div className="float-end">
                                  <Link to="/kepegawaian/laporan_penilaian_skp.html">
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                  </Link>
                                {/* {
                                    (accessRole('create')) ?
                                        <Link to="?create">
                                            <Button color="primary">Tambah Data Laporan Penilaian SKP</Button>
                                        </Link>
                                    : null
                                } */}
                                </div>
                                <CardTitle>Detail Laporan Penilaian SKP</CardTitle>
                                {/* <CardSubtitle className="mb-3">
                                    Kelola Daftar Laporan Penilaian SKP
                                </CardSubtitle> */}
                                <hr />
                                <DetailTableActiveComponent uuid={props.uuid}/>
                            </CardBody>
                        </Card>
                        
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView